import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui"
import { memo } from "react"
import { useTranslation } from "react-i18next"
import { EyeIcon, EyeClosedIcon } from "@phosphor-icons/react"
import { useParams } from "react-router"
import { PeriodTypeView } from "@/types"
import { useFinancialModelSettingsStore } from "@/feature/financial-model/settings/store/financialModelSettingsStore"

export const HistoricalDataButton = memo(
  ({
    showHistoricalData,
    onClick,
  }: {
    showHistoricalData: boolean
    onClick: () => void
  }) => {
    const { t } = useTranslation(`common`)
    const { id: financialModelId } = useParams<{ id: string }>()
    const hasHistoricalData = useFinancialModelSettingsStore(
      (state) =>
        state.settings[financialModelId!]?.timeframe?.historical.isActive
    )
    if (!hasHistoricalData) return null
    return (
      <Button size={`md`} onClick={onClick}>
        {showHistoricalData ? (
          <EyeClosedIcon className="mr-2" size={16} />
        ) : (
          <EyeIcon className="mr-2" size={16} />
        )}
        {showHistoricalData
          ? t(`table.hide_historical_data`)
          : t(`table.show_historical_data`)}
      </Button>
    )
  }
)

HistoricalDataButton.displayName = `HistoricalDataButton`

export const ViewSwitcher = memo(
  ({
    view,
    onViewChange,
  }: {
    view: PeriodTypeView
    onViewChange: (v: PeriodTypeView) => void
  }) => {
    const { t } = useTranslation(`common`)
    return (
      <Select value={view} onValueChange={onViewChange}>
        <SelectTrigger className="min-w-32 max-w-48 w-full border-gray-200">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="yearly">{t(`table.y_view`)}</SelectItem>
          <SelectItem value="monthly">{t(`table.m_view`)}</SelectItem>
        </SelectContent>
      </Select>
    )
  }
)

ViewSwitcher.displayName = `ViewSwitcher`
